import {
    PhysioConsultationOutcomeEnum,
    getEnumKeys,
    getEnumTranslationByKey,
} from '@/shared/enums';

const physioOutcomeOptions = getEnumKeys(PhysioConsultationOutcomeEnum).map(
    (key) => {
        const value = PhysioConsultationOutcomeEnum[key];
        return {
            value,
            label: getEnumTranslationByKey(
                PhysioConsultationOutcomeEnum,
                value,
            ),
        };
    },
);

export const getPhysioOutcomeOptions = (isVideo: boolean) =>
    physioOutcomeOptions.filter((option) => {
        if (isVideo) {
            return (
                option.value !==
                    PhysioConsultationOutcomeEnum.NeedMoreInformation &&
                option.value !==
                    PhysioConsultationOutcomeEnum.OfferedVideoConsultation
            );
        }

        return (
            option.value !== PhysioConsultationOutcomeEnum.NoShow &&
            option.value !==
                PhysioConsultationOutcomeEnum.OfferedFollowUpConsultation
        );
    });
